import { GetterTree } from 'vuex';
import { StateInterface } from '../index';
import { OrderInfoInterface } from './state';

const getters: GetterTree<OrderInfoInterface, StateInterface> = {

};

export default getters;
